import React, { useState } from "react";

import Tabs from "../../../components/tabs/Tabs";
import MyTemplates from "./MyTemplates/MyTemplates";
import Template from "./Templates/Template";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import { useNavigate } from "react-router-dom";



const items = [
  {
    key: "1",
    label: "Templates",
    children: (
      <>
        <Template showCreateBtn={true} />
      </>
    ),
  },
  {
    key: "2",
    label: "My Templates",
    children: <MyTemplates />,
  },
];

function Templates() {

  return (
    <>
      <BoxTabs items={items} showRightBtn={true} />
    </>
  );
}

export default Templates;
